import axios from "axios";

export default async function fileUpload(
  file,
  setListItem,
  setLoading,
  auth,
  folder = 'images'
) {
  if (!file) {
    console.error("No file provided");
    return;
  }

  setLoading(true);

  try {
    // Create FormData with file directly
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    // Prepare headers
    const headers = {};
    
    // Don't set Content-Type - let axios set it automatically with boundary for FormData
    if (auth?.token) {
      headers['Authorization'] = `Bearer ${auth.token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/files/upload`,
      formData,
      {
        headers,
        onUploadProgress: (progressEvent) => {
          // Optional: track upload progress
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(`Upload progress: ${percentCompleted}%`);
        },
      }
    );

    setListItem(response?.data?.url);
    setLoading(false);
    return response?.data?.url;
  } catch (error) {
    setLoading(false);
    console.error("Upload ERROR", error);
    
    const errorMessage = error?.response?.data?.message 
      || error?.response?.data?.err 
      || error?.response?.statusText 
      || "Failed to upload file";
    
    // Error will be handled by calling component
    throw new Error(errorMessage);
  }
}
